import { c as _c } from "react/compiler-runtime";
import { client } from '@onefootprint/fetch-dashboard';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { DASHBOARD_ALLOW_ASSUMED_WRITES, DASHBOARD_AUTHORIZATION_HEADER, DASHBOARD_IS_LIVE_HEADER } from '@/config/constants';
import useSession from '@/hooks/use-session';
const useRequestHeaders = () => {
  const $ = _c(9);
  const {
    data: t0,
    isLive,
    isAssumedSessionEditMode
  } = useSession();
  const {
    auth
  } = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== auth || $[1] !== isAssumedSessionEditMode || $[2] !== isLive || $[3] !== queryClient) {
    t1 = () => {
      if (!auth) {
        return;
      }
      client.setConfig({
        headers: {
          [DASHBOARD_AUTHORIZATION_HEADER]: auth,
          [DASHBOARD_IS_LIVE_HEADER]: JSON.stringify(isLive),
          [DASHBOARD_ALLOW_ASSUMED_WRITES]: isAssumedSessionEditMode ? JSON.stringify(true) : null
        }
      });
      queryClient.resetQueries();
    };
    $[0] = auth;
    $[1] = isAssumedSessionEditMode;
    $[2] = isLive;
    $[3] = queryClient;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== auth || $[6] !== isAssumedSessionEditMode || $[7] !== isLive) {
    t2 = [auth, isLive, isAssumedSessionEditMode];
    $[5] = auth;
    $[6] = isAssumedSessionEditMode;
    $[7] = isLive;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
};
export default useRequestHeaders;